import React, { useState } from 'react';

interface Box {
  id: string;
  title: string;
  content: React.ReactNode;
  color?: string;
}

interface JigSawModuleProps {
  backgroundImage?: string;
  backgroundColor?: string;
  boxes: Box[];
}

export const JigSawModule: React.FC<JigSawModuleProps> = ({
  backgroundImage,
  backgroundColor,
  boxes,
}) => {
  const [selectedBox, setSelectedBox] = useState<Box | null>(null);

  return (
    <div className="flex items-center bg-gray-100 justify-center mt-8">
      <div
        className="w-1/2 min-h-[514px] rounded-3xl overflow-hidden p-4 relative flex justify-center items-center"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
          backgroundColor: backgroundImage ? 'transparent' : backgroundColor || '#ddd',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-72 h-72 rotate-45 bg-gray-300 opacity-40"></div>
        </div>

        <div className="grid grid-cols-2 gap-5 w-auto h-48 z-10 ">
          {boxes.map((box) => (
            <button
              key={box.id}
              onClick={() => setSelectedBox(box)}
              className="flex items-center text-[8px] lg:text-lg md:text-sm justify-center text-white font-bold text-sm p-5 px-5 rounded-lg transition-all duration-300"
              style={{ backgroundColor: box.color || '#000' }}
            >
              {box.title}
            </button>
          ))}
        </div>
      </div>

      {/* Right Side */}
      <div className="w-1/2 min-h-[414px] p-6 bg-gray-100 rounded-3xl shadow-lg">
        {selectedBox ? (
          <div>
            <h2
              className="text-xl font-bold text-white px-4 py-2"
              style={{ backgroundColor: selectedBox.color }}
            >
              {selectedBox.title}
            </h2>
            <div className="mt-3 leading-6">{selectedBox.content}</div>
          </div>
        ) : (
          <p className="text-gray-500">Click a box to see details</p>
        )}
      </div>
    </div>
  );
};
